<template lang="pug">
div
  v-expansion-panel.elevation-0
    v-expansion-panel-content
      v-layout(align-center, justify-space-between, slot='header')
        div
          transition(name='fade', mode='out-in')
            v-icon.mr-3(v-if='leaseSettings.businessLeaseForm.enabled' color='green', key='enabled') fa fa-check
            v-icon.mr-3(v-else, key='disabled') fa fa-ban
          span Financial Lease aanvraagformulier

        pricing-dialog.mr-4(
          title='Financial Lease',
          :header='["Soort", "Kosten per aanvraag"]'
          :items='[{ name: "Financial Lease", value: "€ 0,99 excl. BTW" }]'
          )

      lease-form(v-model='leaseSettings.businessLeaseForm', @valid='setValid', lease='businessLease')

  v-expansion-panel.elevation-0
    v-expansion-panel-content
      v-layout(align-center, justify-space-between, slot='header')
        div
          transition(name='fade', mode='out-in')
            v-icon.mr-3(v-if='leaseSettings.privateLeaseForm.enabled' color='green', key='enabled') fa fa-check
            v-icon.mr-3(v-else, key='disabled') fa fa-ban
          span Financieringen / Kredieten aanvraagformulier

        pricing-dialog.mr-4(
          title='Kredietaanvraag',
          :header='["Soort", "Kosten per aanvraag"]'
          :items='[{ name: "Kredietaanvraag", value: "€ 0,99 excl. BTW" }]'
          )

      lease-form(v-model='leaseSettings.privateLeaseForm', @valid='setValid', lease='privatelease')

</template>

<script>
export default {
  props: {
    value: Object
  },

  components: {
    LeaseForm: require('./LeaseForm').default,
    PricingDialog: require('@/components/PricingDialog').default
  },

  data () {
    return {
      leaseSettings: this.value,
      businessLeaseValid: true,
      privateLeaseValid: true
    }
  },

  methods: {
    setValid ({ lease, valid }) {
      this[lease + 'Valid'] = valid
    }
  },

  watch: {
    value (v) {
      this.leaseSettings = v
    },

    leaseSettings: {
      handler: function (v) {
        this.$emit('input', this.leaseSettings)
      },
      deep: true
    },

    businessLeaseValid: {
      handler: function (v) {
        this.$emit('valid', {
          tab: 'tabSettingsForms',
          valid: this.businessLeaseValid && this.privateLeaseValid
        })
      },
      immediate: true
    },

    privateLeaseValid: {
      handler: function (v) {
        this.$emit('valid', {
          tab: 'tabSettingsForms',
          valid: this.businessLeaseValid && this.privateLeaseValid
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
</style>
